import { moduleProviderFactory } from "mrb/core";
import { UploadedContentPage, UploadedContentSessionPage } from "administration/uploaded-content/pages";
import { UploadedContentRouteStore, UploadedContentSessionRouteStore } from "administration/uploaded-content/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "uploaded-content",
        routes: [
            {
                name: "master.administration.uploaded-content",
                pattern: "/uploaded-content",
                children: [
                    {
                        name: "master.administration.uploaded-content.list",
                        pattern: "",
                        component: UploadedContentPage,
                        store: UploadedContentRouteStore,
                        data: { title: "ADMINISTRATION.UPLOADED_CONTENT.LIST.TITLE" },
                    },
                    {
                        name: "master.administration.uploaded-content.session",
                        pattern: "/sessions/:sessionId",
                        component: UploadedContentSessionPage,
                        store: UploadedContentSessionRouteStore,
                        data: { title: "ADMINISTRATION.UPLOADED_CONTENT.SESSION.TITLE" },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.UPLOADED_CONTENT",
                order: 7,
                icon: "uploaded-content",
                route: "master.administration.uploaded-content.list",
            },
        ],
    });
})();
